export enum Profiles {
    AdministradorGeral = 0,
    Administrador = 1,
    Diretor = 2,
    Supervisor = 3,
    Colaborador = 4,
    RespFerramentas = 5,
    Manutencao = 6,
    Repositor = 7,
    Limpeza = 8,
    cliente = 9
  }